<template>
  <div class="web">
    <div class="Empty">
      <div class="EmptyImage">
        <img src="../../../assets/images/cannotAccess.png" alt="" />
      </div>
      <p class="text">页面丢失了...</p>
      <div class="btns" @click="onPage">
      <button class="shopping">返回</button>
    </div>
    </div>
    
  </div>
</template>
<script>
export default {
  methods: {
    onPage() {
      this.$router.replace("page");
    }
  }
};
</script>
<style lang="less" scoped>
.text {
  color: #9b9b9b;
  margin: 9vw 0 11vw;
  font-size: 5.86667vw;
}
</style>
